import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState, useCallback } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { getPosts, deletePost, getCategories, deleteCategory, createCategory, updateCategory } from "../../api/blog";
export default function BlogList() {
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const [tab, setTab] = useState("posts");
    const [data, setData] = useState(null);
    const [categories, setCategories] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");
    const [newCat, setNewCat] = useState("");
    const [editingCatId, setEditingCatId] = useState(null);
    const [editingCatName, setEditingCatName] = useState("");
    const page = Number(searchParams.get("page") || 1);
    const fetchPosts = useCallback(async () => {
        setLoading(true);
        try {
            const res = await getPosts({ page, pageSize: 15, q: searchParams.get("q") || undefined, durum: searchParams.get("durum") || undefined });
            setData(res);
        }
        catch (err) {
            setError(err?.response?.data?.error || "Yüklenemedi");
        }
        finally {
            setLoading(false);
        }
    }, [page, searchParams]);
    const fetchCategories = useCallback(async () => {
        try {
            const cats = await getCategories();
            setCategories(cats);
        }
        catch { /* ignore */ }
    }, []);
    useEffect(() => {
        if (tab === "posts")
            fetchPosts();
        else {
            fetchCategories();
            setLoading(false);
        }
    }, [tab, fetchPosts, fetchCategories]);
    const handleDeletePost = async (id, title) => {
        if (!window.confirm(`"${title}" silinsin mi?`))
            return;
        try {
            await deletePost(id);
            fetchPosts();
        }
        catch {
            alert("Silme başarısız");
        }
    };
    const handleDeleteCat = async (id, name) => {
        if (!window.confirm(`"${name}" kategorisi silinsin mi?`))
            return;
        try {
            await deleteCategory(id);
            fetchCategories();
        }
        catch {
            alert("Silme başarısız");
        }
    };
    const handleAddCat = async () => {
        if (!newCat.trim())
            return;
        try {
            await createCategory({ name: newCat.trim() });
            setNewCat("");
            fetchCategories();
        }
        catch {
            alert("Kategori eklenemedi");
        }
    };
    const startEditCat = (c) => {
        setEditingCatId(c.id);
        setEditingCatName(c.name);
    };
    const saveEditCat = async (id) => {
        if (!editingCatName.trim())
            return;
        try {
            await updateCategory(id, { name: editingCatName.trim() });
            setEditingCatId(null);
            fetchCategories();
        }
        catch {
            alert("Kategori güncellenemedi");
        }
    };
    const durumBadge = (d) => {
        const map = { YAYINDA: "success", TASLAK: "warning", ARSIV: "default" };
        return _jsx("span", { className: `badge badge-${map[d] || "default"}`, children: d });
    };
    return (_jsxs("div", { children: [_jsxs("div", { className: "page-header", children: [_jsx("h2", { className: "page-title", children: "Blog" }), _jsx(Link, { to: "/blog/new", className: "btn btn-primary", children: "+ Yeni Yaz\u0131" })] }), _jsxs("div", { className: "tabs", children: [_jsx("button", { className: `tab ${tab === "posts" ? "active" : ""}`, onClick: () => setTab("posts"), children: "Yaz\u0131lar" }), _jsx("button", { className: `tab ${tab === "categories" ? "active" : ""}`, onClick: () => setTab("categories"), children: "Kategoriler" })] }), error && _jsx("div", { className: "alert alert-error", children: error }), tab === "posts" ? (loading ? _jsx("div", { className: "loading", children: _jsx("div", { className: "spinner" }) }) : (_jsxs(_Fragment, { children: [_jsx("div", { className: "table-wrap", children: _jsxs("table", { className: "table", children: [_jsx("thead", { children: _jsxs("tr", { children: [_jsx("th", { children: "Ba\u015Fl\u0131k" }), _jsx("th", { children: "Kategori" }), _jsx("th", { children: "Durum" }), _jsx("th", { children: "G\u00F6r." }), _jsx("th", { children: "Tarih" }), _jsx("th", { children: "\u0130\u015Flem" })] }) }), _jsx("tbody", { children: data?.items?.length === 0 ? _jsx("tr", { children: _jsx("td", { colSpan: 6, className: "empty-text", children: "Hen\u00FCz yaz\u0131 yok" }) }) : data?.items?.map((p) => (_jsxs("tr", { children: [_jsx("td", { children: _jsx(Link, { to: `/blog/${p.id}`, className: "link", children: p.baslik }) }), _jsx("td", { children: p.kategori?.name || "-" }), _jsx("td", { children: durumBadge(p.durum) }), _jsx("td", { children: p.goruntulenme }), _jsx("td", { className: "text-muted", children: p.yayinTarihi ? new Date(p.yayinTarihi).toLocaleDateString("tr-TR") : "-" }), _jsx("td", { children: _jsxs("div", { className: "action-btns", children: [_jsx("button", { onClick: () => navigate(`/blog/${p.id}`), className: "btn-sm btn-secondary", children: "D\u00FCzenle" }), _jsx("button", { onClick: () => handleDeletePost(p.id, p.baslik), className: "btn-sm btn-danger", children: "Sil" })] }) })] }, p.id))) })] }) }), data && data.pagination.totalPages > 1 && (_jsx("div", { className: "pagination", children: Array.from({ length: data.pagination.totalPages }, (_, i) => i + 1).map((p) => (_jsx("button", { onClick: () => { const pr = new URLSearchParams(searchParams); pr.set("page", String(p)); setSearchParams(pr); }, className: `btn-page ${p === page ? "active" : ""}`, children: p }, p))) }))] }))) : (_jsxs("div", { className: "card", children: [_jsxs("div", { className: "form-row mb-2", children: [_jsx("input", { type: "text", value: newCat, onChange: (e) => setNewCat(e.target.value), placeholder: "Yeni kategori ad\u0131", className: "input" }), _jsx("button", { onClick: handleAddCat, className: "btn btn-primary", children: "Ekle" })] }), _jsxs("table", { className: "table", children: [_jsx("thead", { children: _jsxs("tr", { children: [_jsx("th", { children: "Ad" }), _jsx("th", { children: "Slug" }), _jsx("th", { children: "Yaz\u0131 Say\u0131s\u0131" }), _jsx("th", { children: "\u0130\u015Flem" })] }) }), _jsx("tbody", { children: categories.map((c) => (_jsxs("tr", { children: [_jsx("td", { children: editingCatId === c.id ? (_jsxs("div", { className: "form-row", style: { margin: 0, gap: 6 }, children: [_jsx("input", { type: "text", value: editingCatName, onChange: (e) => setEditingCatName(e.target.value), onKeyDown: (e) => { if (e.key === "Enter")
                                                            saveEditCat(c.id); if (e.key === "Escape")
                                                            setEditingCatId(null); }, className: "input", style: { padding: "4px 8px", fontSize: 13 }, autoFocus: true }), _jsx("button", { onClick: () => saveEditCat(c.id), className: "btn-sm btn-primary", style: { padding: "4px 10px" }, children: "Kaydet" }), _jsx("button", { onClick: () => setEditingCatId(null), className: "btn-sm btn-secondary", style: { padding: "4px 10px" }, children: "\u0130ptal" })] })) : (_jsx("span", { style: { cursor: "default" }, children: c.name })) }), _jsx("td", { className: "text-muted", children: c.slug }), _jsx("td", { children: c._count?.posts || 0 }), _jsx("td", { children: _jsxs("div", { className: "action-btns", children: [_jsx("button", { onClick: () => startEditCat(c), className: "btn-sm btn-secondary", children: "D\u00FCzenle" }), _jsx("button", { onClick: () => handleDeleteCat(c.id, c.name), className: "btn-sm btn-danger", children: "Sil" })] }) })] }, c.id))) })] })] }))] }));
}
